import * as React from 'react';
import View from '@sdk/components/primitives/View';

import { useEditorContainer } from './editorContainer.hooks';
type Props = {
  children: React.ReactNode;
};

export const EditorContainer: React.FC<React.PropsWithChildren<Props>> = ({ children }) => {
  const containerRef = useEditorContainer();

  return <View ref={containerRef}>{children}</View>;
};
